import React, { useEffect, useState } from 'react';
import Nav from '../components/Nav';
import client from '../contenful/client';
import aboutlogo from '../images/aboutLogo.png';
import Footer from '../components/Footer';
import './Contact.css';

const Contact = () => {
  const [contact, setContact] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const entries = await client.getEntries({ content_type: "contact" });
        setContact(entries.items);
      } catch (err) {
        console.error("Error fetching Contentful data:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {contact.map((item, index) => {
        const fields = item.fields;
        const {
          headingPara,
          info,
          title,
          title1Info,
          title2Info,
          title3,
          title3Info,
          title4,
          title4Info
        } = fields;

        return (
          <div key={index} className="contact-page">
           <Nav logo={aboutlogo} hamburgerColor='black' logoSize="300px" className="static-nav" />

            <div className="contact-container">
              {/* Left Side */}
              <div className="contact-left">
                <h1>Contact Us</h1>
                <p>{headingPara}</p>
              </div>

              {/* Right Side */}
              <div className="contact-right">
                {/* First Row: info and title */}
                <div className="info-grid">
                  <div className="info-block">
                    <h4>{info}</h4>
                    {title1Info.map((item, i) => (
                      <p key={i}>{item}</p>
                    ))}
                  </div>

                  <div className="info-block">
                    <h4>{title}</h4>
                    <p>{title2Info}</p>
                  </div>
                </div>

                {/* Second Row: title3 and title4 */}
                <div className="contact-info-section">
                  <div className="info-block">
                    <h4>{title3}</h4>
                    {title3Info.map((item, i) => (
                      <p key={i}>{item}</p>
                    ))}
                  </div>

                  <div className="info-block">
                    <h4>{title4}</h4>
                    <ul>
                      {title4Info.map((opening, i) => (
                        <li key={i}>{opening}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Google Map */}
                <div className="map-container">
                  <iframe
                    src="https://www.google.com/mapars/embed?pb=!1m18!1m12!1m3!1d3559.8355272745914!2d75.76024591504303!3d26.861529983151406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5c0fd49e6ed%3A0x5a9733509bde4a9c!2sICICI%20Bank%2C%20Heerapath!5e0!3m2!1sen!2sin!4v1614173094711!5m2!1sen!2sin"
                    width="100%"
                    height="400"
                    
                    style={{ border: 0 ,
                    filter: 'grayscale(100%)'}}
                    allowFullScreen=""
                    loading="lazy"
                    title="Office Location"
                  ></iframe>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        );
      })}
    </>
  );
};

export default Contact;
